import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'
import logger from 'redux-logger'
import rootReducer from './reducer'

const middlewares = [thunk]
if (process.env.NODE_ENV === 'development') {
  // Add redux-logger only in development
  middlewares.push(logger)
}

const composedEnhancer = composeWithDevTools(
  // Add whatever middleware you want to use here
  applyMiddleware(...middlewares),
  // other store enhancers if any
)

const store = createStore(rootReducer, composedEnhancer)
export default store
